import axios, { getEnv } from './api';
import Axios from "axios";

// FILTERS
function filterRoutes(fill) {
    let url = '';
    // DATA INICIAL
    if (fill?.dataFinal && !fill?.dataInicial) {
        url = `?dataFim=${fill?.dataFinal}`;
        return url;
    }
    // DATA FINAL E INICIAL
    else if (
        fill?.dataFinal &&
        fill?.dataInicial &&
        !fill?.cidades &&
        !fill?.ufs
    ) {
        url = `?dataInicio=${fill?.dataInicial}&dataFim=${fill?.dataFinal}`;
        return url;
    }
    // TODOS
    else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs && fill?.cidades) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}&dataFim=${
            fill?.dataFinal
        }&dataInicio=${fill?.dataInicial}&uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }
    // DATA FINAL/INICIAL E UF
    else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs) {
        url = `?dataFim=${fill?.dataFinal}&dataInicio=${
            fill?.dataInicial
        }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }

    // UF E CIDADE
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        fill?.ufs &&
        fill?.cidades
    ) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}&uf=${fill?.ufs?.map(
            (uf) => uf.id
        )}`;
        return url;
    }
    // CIDADE
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        !fill?.ufs &&
        fill?.cidades
    ) {
        url = `?cidade=${fill?.cidades?.map((c) => c.id)}`;
        return url;
    }
    // UF
    else if (
        !fill?.dataFinal &&
        !fill?.dataInicial &&
        !fill?.cidades &&
        fill?.ufs
    ) {
        url = `?uf=${fill?.ufs?.map((uf) => uf.id)}`;
        return url;
    }
    return url;
}

const dashboardServiceAcessos = {
    getTotal: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/total${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getUsuariosUnicos: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/usuarios-unicos${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getMediaUsuario: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/media${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getDistribuicaoDia: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/hora${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPerfilUsuario: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/perfil-usuario${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorcemPerfilUsuario: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/porcentagem-perfil-usuario${filterRoutes(
                    filters
                )}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getPorteEmpresa: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/porte${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getTempoMedio: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/tempo-medio${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getUF: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/uf${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    getUfUnico: async (filters, controller) => {
        try {
            const res = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/acesso/dashboard/uf-unico${filterRoutes(filters)}`,
                {signal: controller}
            );
            return res;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
};

export default dashboardServiceAcessos;
